module.exports = __webpack_public_path__ + "static/media/do.34a43d3c.svg";